import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';

import { TaxB2PRoutingModule } from './tax-b2p-routing.module';
import { TaxB2PComponent } from './tax-b2p.component';
import {CalendarModule} from 'primeng/primeng';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {CoreModule} from '../../core/core.module';
import {TableModule} from 'primeng/table';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    TaxB2PRoutingModule,
    DropdownModule,
    FormsModule,
    CalendarModule,
    NgbDropdownModule,
    CoreModule,
    TableModule,
    TranslateModule
  ],
  declarations: [
    TaxB2PComponent
  ]
})
export class TaxB2PModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/tax-b2p/tax-b2p.module.ts